import {
  type FC,
  type PropsWithChildren as ProtectedObserveRouteProps,
} from 'react';

import { useObserveRoute, useHomePageRedirect } from './hooks';

export const ProtectedRoute: FC<ProtectedObserveRouteProps> = ({
  children,
}) => {
  useHomePageRedirect();
  useObserveRoute();

  return <>{children}</>;
};
